// Client for Forecast / Prediction Models (/api/forecast). Sends the signed-in role on every call.
import { useCallback, useEffect, useState } from "react";
import { headers, parse } from "./classificationApi";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/forecast`;
const get = (p) => fetch(`${BASE}${p}`, { headers: headers(null, false) }).then(parse);
const q = (id) => `id=${encodeURIComponent(id)}`;

export const getPage = (page) => get(`/pages/${page}`);
export const getSeries = (sku) => get(`/demand/series?sku=${encodeURIComponent(sku)}`);
export const getLine = (id) => get(`/line?${q(id)}`);
export const explainLine = (id) => fetch(`${BASE}/line/explain?${q(id)}`, { method: "POST", headers: headers(null, true) }).then(parse);
export const getSource = (id, params) => get(`/line/source?${q(id)}&${new URLSearchParams(params)}`);

export function usePage(page) {
  const [state, setState] = useState({ data: null, error: null, forbidden: false });
  const load = useCallback(() => {
    setState(s => ({ ...s, error: null, forbidden: false }));
    getPage(page).then(data => setState({ data, error: null, forbidden: false })).catch(e => setState({ data: null, error: e.message, forbidden: e.status === 403 }));
  }, [page]);
  useEffect(() => { load(); }, [load]);
  return { ...state, reload: load };
}

export const testid = (id) => id.replace(/[^a-zA-Z0-9]+/g, "-").replace(/-+$/, "").toLowerCase();

export function peso(v) {
  if (v === null || v === undefined) return "—";
  const a = Math.abs(v);
  if (a >= 1e9) return `₱${(v / 1e9).toFixed(2)}B`;
  if (a >= 1e6) return `₱${(v / 1e6).toFixed(1)}M`;
  if (a >= 1e3) return `₱${(v / 1e3).toFixed(0)}K`;
  return `₱${Math.round(v).toLocaleString("en-PH")}`;
}

export const pct0 = (p) => (p === null || p === undefined ? "—" : `${Math.round(p * 100)}%`);

export function whenText(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("en-PH", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export const SUBNAV = [
  { to: "/forecast/overview", label: "Overview", id: "overview" },
  { to: "/forecast", label: "Demand Forecast", id: "demand", end: true },
  { to: "/forecast/stockout", label: "Stockout Risk Prediction", id: "stockout" },
  { to: "/forecast/reorder", label: "Reorder & Replenishment Prediction", id: "reorder" },
  { to: "/forecast/aging", label: "Aging & Slow-Stock Risk", id: "aging" },
  { to: "/forecast/weather", label: "Weather-Driven Demand", id: "weather" },
  { to: "/forecast/cash", label: "Cash & Working Capital Forecast", id: "cash", roles: ["ceo", "cfo", "coo"] },
];
// The CFO sees only the Overview and the cash model; the cash model is limited to the CEO, CFO and COO.
export const subnavFor = (roleId) => SUBNAV.filter(t => (roleId === "cfo" ? ["overview", "cash"].includes(t.id) : !t.roles || t.roles.includes(roleId)));
